import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { parseAsync } from 'json2csv';
import { saveAs } from 'file-saver';
import clsx from 'clsx';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core//CircularProgress';
import { green } from '@material-ui/core/colors';
import Button from '@material-ui/core//Button';
import Fab from '@material-ui/core//Fab';
import CheckIcon from '@material-ui/icons/Check';
import SaveIcon from '@material-ui/icons/Save';
import GetAppIcon from '@material-ui/icons/GetApp';

const CsvButton = ({ classes, allDataRef }) => {
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const timer = React.useRef();

  const dataToCsvFormat = async (data) => {
    const result = parseAsync(data)
      .then((csv) => csv)
      .catch((err) => {
        toast.error('Failed to convert data to csv!');
        // eslint-disable-next-line no-console
        console.error(err);
      });
    return result;
  };

  const csvDataToFile = useCallback(async (type, csvData) => {
    try {
      const csvFile = new File(
        [...csvData],
        `${type}-${new Date().toISOString().slice(0, 10)}.csv`
      );
      saveAs(csvFile);
    } catch (err) {
      toast.error('Failed to create Csv File!');
      // eslint-disable-next-line no-console
      console.error(err);
    }
  }, []);

  const handleSuccess = async () => {
    setSuccess(true);
    timer.current = window.setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const handleButtonClick = async () => {
    if (!loading) {
      setLoading(true);
    }
  };

  useEffect(() => {
    if (loading) {
      const downloadCsv = async () => {
        const { type, data } = allDataRef.current;
        const csvData = await dataToCsvFormat(data);
        await csvDataToFile(type, csvData);
        timer.current = window.setTimeout(async () => handleSuccess(), 1000);
      };
      downloadCsv();
    }
  }, [loading, allDataRef, csvDataToFile]);

  useEffect(() => {
    return () => clearTimeout(timer);
  }, [timer]);

  return (
    <>
      <Box
        m={1}
        style={{
          display: 'flex',
          justifyContent: 'center',
          position: 'relative',
          width: 100,
          marginLeft: 2,
        }}
      >
        {loading ? (
          <>
            <Fab
              aria-label="save"
              color="primary"
              className={clsx(success && classes.successCsv)}
            >
              {success ? <CheckIcon /> : <SaveIcon />}
            </Fab>

            <CircularProgress
              size={68}
              style={{
                color: green[500],
                position: 'absolute',
                top: -6,
                left: 16,
                zIndex: 1,
              }}
            />
          </>
        ) : (
          <Button
            className={classes.csvButton}
            variant="outlined"
            color="primary"
            startIcon={<GetAppIcon />}
            size="large"
            onClick={handleButtonClick}
          >
            CSV
          </Button>
        )}
      </Box>
    </>
  );
};

CsvButton.defaultProps = {
  allDataRef: {},
  classes: {},
};

CsvButton.propTypes = {
  allDataRef: PropTypes.object,
  classes: PropTypes.any,
};

export default CsvButton;
